module.exports = __webpack_public_path__ + "img/register-completd.767d8107.png";